// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductProperties_item__1MHgg","dashedLine":"ProductProperties_dashedLine__bmqXw","radioFormGroup":"ProductProperties_radioFormGroup__3Z0lQ"};